import React from "react";
import "./style.scss";

const DoneProgress = ({ children, dataProgress, maxValue }) => {
  return (
    <div>
      {children}
      <div className="done-progress">
        <div
          className="done-progress--bar "
          style={{ width: (dataProgress / maxValue) * 100 + "%" }}
        />
      </div>
    </div>
  );
};

export default DoneProgress;
